<template>
    <div class="salary-info">
        <el-card shadow="always">
            <el-form :model="userSalaryForm" :rules="rules" ref="userSalaryForm" label-width="105px" class="demo-ruleForm"
                id="form">
                <el-form-item prop="account" label="账号:">
                    <el-input type="number" v-model.trim="userSalaryForm.account" size="mini" clearable></el-input>
                </el-form-item>
                <el-form-item prop="user" label="户名:">
                    <el-input v-model.trim="userSalaryForm.user" size="mini" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item prop="salary" label="金额:">
                </el-form-item> -->
                <el-form-item label="所属公司" prop="">
                  <el-select v-model="btc" placeholder="请选择所属公司" filterable clearable size="mini" style="width: 100%">
                    <el-option label="上海优开信息科技有限公司" :value="1"></el-option>
                    <el-option label="上海账六六信息科技有限公司" :value="2"></el-option>
                    <el-option label="云上飕飕（上海）企业管理有限公司" :value="3"></el-option>
                    <el-option label="鑫项云企业服务（上海）有限公司" :value="4"></el-option>
                    <el-option label="优开财务顾问（上海）有限公司" :value="5"></el-option>
                    <el-option label="畅享无忧财务顾问（上海）有限公司" :value="6"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="bank_default">
                    <template>
                        <div slot="label">
                            <p>跨行标识:</p>
                            <el-tooltip class="item" effect="dark" content="默认建行(不跨行),跨行请选跨行" placement="top">
                                <p
                                    style="margin-top: -25px;font-size: xx-small;color: #E6A23C;white-space: nowrap;width: 105px;overflow: hidden;text-overflow: ellipsis;">
                                    <i class="el-icon-s-opportunity"></i>默认建行(不跨行),跨行请选跨行
                                </p>
                            </el-tooltip>
                        </div>
                    </template>
                    <el-radio-group v-model="userSalaryForm.bank_default" size="mini">
                        <el-radio-button :label="0">不跨行</el-radio-button>
                        <el-radio-button :label="1">跨行</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="bank">
                    <template>
                        <div slot="label">
                            <p>行名:</p>
                            <el-tooltip class="item" effect="dark" content="跨行业务与行名不能同时为空" placement="top">
                                <p
                                    style="margin-top: -25px;font-size: xx-small;color: #E6A23C;white-space: nowrap;width: 105px;overflow: hidden;text-overflow: ellipsis;">
                                    <i class="el-icon-s-opportunity"></i>跨行业务与行名不能同时为空
                                </p>
                            </el-tooltip>
                        </div>
                    </template>
                    <el-input v-model.trim="userSalaryForm.bank" size="mini" clearable></el-input>
                </el-form-item>
                <el-form-item prop="bank_code">
                    <template>
                        <div slot="label">
                            <p>联行行号:</p>
                            <el-tooltip class="item" effect="dark" content="跨行业务与联行行号不能同时为空" placement="top">
                                <p
                                    style="margin-top: -25px;font-size: xx-small;color: #E6A23C;white-space: nowrap;width: 105px;overflow: hidden;text-overflow: ellipsis;">
                                    <i class="el-icon-s-opportunity"></i>跨行业务与联行行号不能同时为空
                                </p>
                            </el-tooltip>
                        </div>
                    </template>
                    <el-input type="number" v-model.trim="userSalaryForm.bank_code" size="mini" clearable></el-input>
                </el-form-item>
                <el-form-item prop="abstract">
                    <template>
                        <div slot="label">
                            <p>摘要:</p>
                            <el-tooltip class="item" effect="dark" content="显示在收款账户流水明细中" placement="top">
                                <p
                                    style="margin-top: -25px;font-size: xx-small;color: #E6A23C;white-space: nowrap;width: 105px;overflow: hidden;text-overflow: ellipsis;">
                                    <i class="el-icon-s-opportunity"></i>显示在收款账户流水明细中
                                </p>
                            </el-tooltip>
                        </div>
                    </template>
                    <el-input size="mini" type="textarea" v-model="userSalaryForm.abstract" placeholder=""
                        style="white-space: pre" :maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="notes" label="备注:">
                    <el-input size="mini" type="textarea" v-model="userSalaryForm.notes" placeholder=""
                        style="white-space: pre" :maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <div style="text-align: right;">
                        <el-button type="primary" size="mini" @click="submitForm('userSalaryForm')">提交</el-button>
                        <el-button @click="resetForm('userSalaryForm')" size="mini">重置</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'SalaryInfo',
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        },
        b_company: {
            type: Number
        }
    },
    data() {
        return {
            tablelData: [],
            userSalaryForm: {
                account: '',
                user: '',
                bank_default: '',
                bank: '',
                bank_code: '',
                abstract: '',
                notes: '',
            },
            btc: '',
            adminuserId: '',
            adminuserName: '',
            bCompany: '',
            tableEmployeeSalaryId: null,
            rules: {
                account: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { min: 16, max: 19, message: '长度在 16 到 19 个字符', trigger: 'blur' }
                ],
                user: [
                    { required: true, message: '请输入用户', trigger: 'blur' },
                    { min: 2, max: 25, message: '最少2位,不能输入过长', trigger: 'blur' }
                ],
                bank: [
                    { min: 2, max: 25, message: '输入不正确', trigger: 'blur' },
                    { message: '格式有误', trigger: 'blur', pattern: /^[\u4e00-\u9fa5]+$/ }
                ],
                bank_code: [
                    { min: 12, max: 12, message: '请输入12位联行行号', trigger: 'blur' },
                ]
            }
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n,o) {
                this.btc = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getUserSalaryInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n,o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        b_company: {
            immediate: true,
            handler(n,o) {
                this.btc = null
                if (n !== o) {
                    this.btc = n
                }
            }
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmitForm()
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.btc = null
        },
        doSubmitForm() {
            if (this.userSalaryForm.bank_default === '' || this.userSalaryForm.bank_default === null) {
                if (!this.userSalaryForm.bank || !this.userSalaryForm.bank_code) {
                    this.$message.warning('跨行标识与(行名和联行行号)不能同时不写!')
                    return false
                }
            }
            this.userSalaryForm.adminuser_id = this.adminuserId
            this.userSalaryForm.belong_to_company = this.btc
            this.$axios.post('api/api3_commit_userinfo',
                this.userSalaryForm
            ).then(({data}) => {
                if (data.code === 200) {
                    this.$message.success(data.msg)
                }else{
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getUserSalaryInfo(adminuser_id) {
            if (this.$refs['userSalaryForm']) this.resetForm('userSalaryForm')
            this.$axios.get('api/api3_get_userinfo',{
                params: {
                    adminuser_id
                }
            }).then(({data}) => {
                if (data.code === 200) {
                    if (data.data) {
                        this.userSalaryForm = data.data
                    }
                    this.userSalaryForm.user = !this.userSalaryForm.user? this.adminuserName : this.userSalaryForm.user
                }
            }).catch()
        }
    },
}
</script>

<style scoped>
/* #form>>>.el-form-item__label {
    font-size: larger !important;
    font-weight: bold;
} */
</style>


// WEBPACK FOOTER //
// src/pages/authority/SalaryInfo.vue